import { store } from '@/store/index';
import { defineAsyncComponent } from 'vue';
import type { Component } from 'vue';

export default (importFunc: () => Promise<Component>): Component =>
  defineAsyncComponent(
    () =>
      new Promise((resolve) => {
        store.commit('global/loaderStart');
        importFunc()
          .then((component: Component) => {
            resolve(component);
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            store.commit('global/loaderStop');
          });
      })
  );
